import { CLEAR_PAGE } from '../base/types';
import { FETCH_USER_CHECKOUTS_HISTORY } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const userReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_USER_CHECKOUTS_HISTORY}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_USER_CHECKOUTS_HISTORY}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_USER_CHECKOUTS_HISTORY}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'userCheckoutsHistory' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default userReducer;
